import { render } from "./CashRelief.vue?vue&type=template&id=562a0182"
import script from "./CashRelief.vue?vue&type=script&lang=js"
export * from "./CashRelief.vue?vue&type=script&lang=js"

import "./CashRelief.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__